import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csinherit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# inheritance tutorial For Beginners</title>
 <meta name="description" content="C# inheritance tutorial for beginners.inheritance in C# is the main concept of oops by which we can create parent and child class.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# inheritance,c# inheritance for,c sharp inheritance,Inheritance C# tutorial For Begineers" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-inheritance" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Inheritance in CSharp(C#)</h1>
    <div className="first">
        <a href="/csharp-constructor">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-single-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">What is inheritance in c#</h2>
    <p className="mt-4 para">1, Inheritance in c# is important because it supports the concept of hierarchical classification<br/>
2, Inheritance is the main concept of oops by which we can create parent and child class.<br/>
3, Inheritance in c# it inherits the property of parent class into child class. This is also known as inheritance<br/>
4, A parent class is a superclass <br/>
</p>

<h2 className="mt-4 mh2">Advantages and disadvantages of inheritance in c#:
</h2>
<h3 className="mt-4 mh3">Advantage of inheritance in C#:

</h3>

<p className="mt-4 para">A child class is a subclass<br/>
the main advantage of inheritance is that we can access the member of the superclass directly (without creating an object).<br/>
Inheritance is code reusability<br/>
Construct can’t inherit in another class because is not the part of the class<br/>
The private method can’t call when child class call superclass inside methods<br/>
</p>

<h3 className="mt-4 mh3">Disadvantage of inheritance in C#:
</h3>
<p className="mt-4 para">1, Inheritance give tightly coupled means after use extends   between two class are tightly coupled  occupy more space or memory<br/>
2, For the reason of tightly coupled, when you change inside any class so show changes in another class<br/>
</p>
<h2 className="mt-4 mh2">
Inheritance basics in c#:
</h2>
<p className="mt-4 para">You can access the member of the superclass directly by the use of extends keyword means subclass adds to the superclass by using extend keyword. and this inheritance in c# interview questions put up in many MNC companies.
</p>
<h2 className="mt-4 mh2">This is inheritance IS-A relationship in C#:
</h2>



<h2 className="headings">Syntax of inheritance in C#:</h2>
<div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">Teacher </span>
            <span className="qwerty-5">IS-A </span>
            <span className="qwerty-3">students</span>
            {"\n"}
            {"\n"}
            <span className="qwerty-7">this is the</span>
            <span className="qwerty-2"> Syntax of </span>
            <span className="qwerty-5">IS-A </span>
            <span className="qwerty-1">relationship </span>
            <span className="qwerty-4">in </span>
            <span className="qwerty-7">inheritance</span>
            {"\n"}
            {"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Example of inheritance in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-6">class </span>
            <span className="qwerty-5">students</span>
            <span className="qwerty-4"> // </span>
            <span className="qwerty-5">superclass or parent class </span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-5">void </span>
            <span className="qwerty-4">learn </span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">Console.</span>
            <span className="qwerty-5">WriteLine </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-7">this is </span>
            <span className="qwerty-4">a </span>
            <span className="qwerty-6">students</span>
            <span className="qwerty-2">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-6">class </span>
            <span className="qwerty-4">teachers </span>
            <span className="qwerty-1">extends</span>
            <span className="qwerty-4"> students</span>
            <span className="qwerty-4"> // </span>
            <span className="qwerty-5">teachers is a child class</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-7">public</span>
            <span className="qwerty-2"> static</span>
            <span className="qwerty-1"> void </span>
            <span className="qwerty-4">main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-1">String</span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-4">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-1">&#123;</span>
            {"\n"}
            <span className="qwerty-4">teachers </span>
            <span className="qwerty-7">t</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-5">new </span>
            <span className="qwerty-4">teachers</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">t.learn</span>
            <span className="qwerty-2">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}
            <span className="qwerty-1">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">this is </span>
            <span className="qwerty-4">a </span>
            <span className="qwerty-6">students </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className="mt-4 mh2">Types of inheritance in c#:
</h2>

<h3 className="mt-4 mh3">1, Single inheritance in c#<br/>
2, Multilevel inheritance in c#<br/>

</h3>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-constructor"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-single-inheritance"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csinherit;